"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Highlight = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var parse_1 = __importDefault(require("autosuggest-highlight/parse"));
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var Highlight_style_1 = __importDefault(require("./Highlight.style"));
/**
 * Highlight atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-highlight--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/Highlight Source}
 */
var Highlight = function (_a) {
    var text = _a.text, textToHighlight = _a.textToHighlight, bold = _a.bold;
    var classes = (0, Highlight_style_1.default)();
    if (!textToHighlight) {
        return (0, jsx_runtime_1.jsx)("span", { children: text });
    }
    var matches = findMatches(text, textToHighlight);
    var parts = (0, parse_1.default)(text, matches);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: parts.map(function (part, index) {
            return part.highlight ? ((0, jsx_runtime_1.jsx)("span", __assign({ className: (0, classnames_1.default)(bold ? classes.highlightBold : classes.highlight, 'mark') }, { children: part.text }), index)) : ((0, jsx_runtime_1.jsx)("span", { children: part.text }, index));
        }) }));
};
exports.Highlight = Highlight;
function findMatches(text, query) {
    var match;
    var regex = new RegExp((0, lodash_1.escapeRegExp)(query), 'gi');
    var matches = [];
    while ((match = regex.exec(text)) != null) {
        matches.push([match.index, regex.lastIndex]);
    }
    return matches;
}
